import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { Shield, User } from "lucide-react";

export default function AdminModeToggle({ variant = "default", size = "sm", showText = true }) {
  const navigate = useNavigate();
  const { isAdmin, adminMode, toggleAdminMode } = useAuth();

  if (!isAdmin) {
    return null;
  }

  const handleToggle = () => {
    toggleAdminMode();
    if (!adminMode) {
      navigate("/admin");
    } else {
      navigate("/home");
    }
  };

  return (
    <Button
      variant={adminMode ? "destructive" : variant === "default" ? "outline" : variant}
      size={size}
      onClick={handleToggle}
      className="flex items-center gap-2"
    >
      {adminMode ? (
        <>
          <User className="h-4 w-4" />
          {showText && <span className="hidden sm:inline">User Mode</span>}
        </>
      ) : (
        <>
          <Shield className="h-4 w-4" />
          {showText && <span className="hidden sm:inline">Admin Mode</span>}
        </>
      )}
    </Button>
  );
}